// Copyright (c) 2016 Deere & Company

import t from 'tcomb';

const Column = t.struct({
    key: t.String,
    value: t.String
}, 'Column');

export default Column;



// WEBPACK FOOTER //
// ./src/reports/dealer-transfer-history/state/column.js